document.addEventListener("DOMContentLoaded", () => {
    const customNewsletter = document.querySelector('#custom-newsletter');

    if (!customNewsletter) {
        throw new Error('Form error')
    }


    const showFormButton = customNewsletter.querySelector('#show-form-button');
    const initialForm = customNewsletter.querySelector('#initial-form');
    const signupForm = customNewsletter.querySelector('#signup-form');
    if (showFormButton && initialForm && signupForm) {
        showFormButton.addEventListener('click', handleShowFormButtonClick)
    }

    const copyToClipboardButton = customNewsletter.querySelector('#copy-to-clipboard');

    if (copyToClipboardButton) {
        copyToClipboardButton.addEventListener('click', handleCopyToClipboard)
    }


    function handleShowFormButtonClick(ev) {
        ev.preventDefault();
        initialForm.classList.add('hidden');
        signupForm.classList.remove('hidden');
    }

    async function handleCopyToClipboard(ev) {
        ev.preventDefault();

        const code = ev.target.getAttribute('data-discount-code');

        try {
            await navigator.clipboard.writeText(code)
            const icon = copyToClipboardButton.querySelector('i');

            icon.classList.remove('ph-clipboard');
            icon.classList.add('ph-check');

            setTimeout(() => {
                icon.classList.remove('ph-check');
                icon.classList.add('ph-clipboard');
            }, 2000);

        } catch (e) {
            console.error('Failed to copy: ', e);
        }
    }
});